import React from 'react';

export const BaseLayout = ({ children }) => {
  return (
    <>
      <div className="base-layout">{children}</div>
    </>
  );
};
